import {
  AfterViewInit,
  ChangeDetectionStrategy, 
  Component, 
  Input,
  Output,
  OnChanges, 
  ViewEncapsulation,
  EventEmitter
} from '@angular/core'; 

import { diffMonths} from "@knz/util";
export interface IFishbone {
  date: string | Date;
  title?: ""; 
}

@Component({
  selector: 'card-fishbone', 
  exportAs: 'card-fishbone',
  templateUrl: './card-fishbone.component.html', 
  host: { '[class.card-fishbone]': 'true' },
  preserveWhitespaces: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class CardFishboneComponent implements AfterViewInit, OnChanges {
  @Input() data:IFishbone[]=[]; 
  @Input() first: string; 
  @Output() itemClickEvent = new EventEmitter<any>();
   
  constructor() {}

  ngAfterViewInit() { 
  }

  ngOnChanges() { 
  }

  
  cardClick() { 
    this.itemClickEvent.emit(this.data);
  }

  getItemWidth(item:any,index:number){
    let result="20%"
    if(this.data!=null && this.data.length>1){
      let begin =this.data[0].date;
      let end =this.data[this.data.length-1].date;
      if(begin!=undefined && end!=undefined && this.data.length!= (index+1)){ 
        let total = diffMonths(begin,end);
        let xj = diffMonths(item.date,this.data[index+1].date)
        result = (xj/total*0.7)*100+"%"; 
      } 
    }
    return result;
  }
}
